export const ETHEREUM_MAX_INTEGER =
  '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
export const VITA_MAX_APPROVE_AMOUNT = '64298880'
export const VITA_TOKEN_DECIMALS = 18
